import { useEffect, useRef, useState } from 'react';

const steps = [
  { icon: 'ri-chat-3-line', title: '免费咨询', desc: '提供专业咨询服务，了解需求，评估可行性' },
  { icon: 'ri-file-text-line', title: '签订合同', desc: '明确调查事项、方法、周期、费用等，保障双方权益' },
  { icon: 'ri-task-line', title: '制定方案', desc: '根据具体情况，制定专业、高效的调查方案' },
  { icon: 'ri-search-2-line', title: '实施调查', desc: '专业团队执行调查，实时跟进，定期汇报' },
  { icon: 'ri-clipboard-line', title: '整理证据', desc: '收集、整理调查证据，确保真实有效' },
  { icon: 'ri-file-list-3-line', title: '提交报告', desc: '形成详细调查报告，提供专业分析和建议' },
];

const ProcessSection = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [visibleCount, setVisibleCount] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          let count = 0;
          const timer = setInterval(() => {
            count += 1;
            setVisibleCount(count);
            if (count >= steps.length) clearInterval(timer);
          }, 150);
        }
      },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-20 bg-[#0f1a14] relative overflow-hidden">
      {/* Glow */}
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-64 h-64 bg-[#c9a84c]/4 rounded-full blur-3xl pointer-events-none"></div>

      <div className="max-w-4xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="w-8 h-px bg-gradient-to-r from-transparent to-[#c9a84c]"></span>
            <span className="text-[#c9a84c] text-xs font-semibold tracking-widest uppercase">How It Works</span>
            <span className="w-8 h-px bg-gradient-to-l from-transparent to-[#c9a84c]"></span>
          </div>
          <h2 className="text-2xl md:text-3xl font-black text-white mb-2">调查流程</h2>
          <p className="text-white/35 text-sm">专业规范的调查流程保障</p>
        </div>

        <div ref={ref} className="relative">
          {/* Animated vertical line */}
          <div className="absolute left-6 top-0 bottom-0 w-px hidden sm:block overflow-hidden">
            <div
              className="w-full bg-gradient-to-b from-[#c9a84c] via-[#c9a84c]/50 to-transparent"
              style={{
                height: `${(visibleCount / steps.length) * 100}%`,
                transition: 'height 0.3s ease',
              }}
            ></div>
          </div>

          <div className="space-y-4">
            {steps.map((step, idx) => (
              <div
                key={step.title}
                className="flex items-start gap-5 group"
                style={{
                  opacity: visibleCount > idx ? 1 : 0,
                  transform: visibleCount > idx ? 'translateX(0)' : 'translateX(-20px)',
                  transition: 'opacity 0.4s ease, transform 0.4s ease',
                }}
              >
                {/* Step number circle */}
                <div className="relative z-10 flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-full font-black text-sm text-[#0f1a14] bg-[#c9a84c] group-hover:scale-110 transition-transform duration-300">
                  {idx + 1}
                  {/* Pulse ring */}
                  <span className="absolute inset-0 rounded-full border-2 border-[#c9a84c]/40 scale-125 opacity-0 group-hover:opacity-100 group-hover:scale-150 transition-all duration-500"></span>
                </div>

                {/* Card */}
                <div className="flex-1 bg-[#162218] rounded-xl p-4 border border-[#c9a84c]/10 group-hover:border-[#c9a84c]/50 transition-all duration-300 relative overflow-hidden">
                  <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-[#c9a84c]/6 to-transparent skew-x-12 pointer-events-none"></span>
                  <div className="flex items-center gap-2 mb-1">
                    <i className={`${step.icon} text-[#c9a84c] text-base`}></i>
                    <h3 className="text-sm font-bold text-white group-hover:text-[#c9a84c] transition-colors duration-300">{step.title}</h3>
                  </div>
                  <p className="text-xs text-white/45 leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
